import { MembershipProgramListApiResponse } from '@navio/nsdk';
import { URLKeys } from 'noddi-async';
import { type FilterOptionSource, usePagination } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { toFilterOptionSource, useFilterOptionsGet } from '../useFilterOptionsGet';

/** Membership programs as filter options, searchable. For `unit.multiSelect`. */
export const useMembershipProgramOptions = ({
  userGroupIds
}: { userGroupIds?: number[] } = {}): FilterOptionSource<number> => {
  const { pageIndex, pageSize, search, setSearch } = usePagination();
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getPaginatedMembershipPrograms,
    input: { pageIndex, pageSize, search: debouncedSearch, userGroupIds },
    queryConfig: { select: toMembershipProgramOptions }
  });

  return toFilterOptionSource(query, 'number', { search, onSearch: setSearch });
};

const toMembershipProgramOptions = ({ results }: MembershipProgramListApiResponse) =>
  results.map((membershipProgram) => ({
    value: membershipProgram.id,
    label: membershipProgram.name,
    imageUrl: membershipProgram.image?.url
  }));
